var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form",
    {
      staticClass: "d-flex justify-content-end",
      class: { "navbar-searchbar-desktop-container": _vm.isDesktop },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.goToSearch.apply(null, arguments)
        }
      }
    },
    [
      _c(
        "b-input-group",
        { staticClass: "flex-nowrap", attrs: { size: "sm" } },
        [
          _c("b-form-input", {
            ref: "searchInput" + _vm.id,
            staticClass: "search-input",
            class: { active: _vm.search },
            attrs: {
              placeholder: _vm.$t("Research"),
              maxlength: "250",
              type: "search"
            },
            on: { input: _vm.onInput },
            model: {
              value: _vm.search,
              callback: function($$v) {
                _vm.search = $$v
              },
              expression: "search"
            }
          }),
          _vm._v(" "),
          _c(
            "b-input-group-append",
            [
              _c(
                "b-input-group-text",
                {
                  staticClass: "search-input-append",
                  on: { click: _vm.goToSearch }
                },
                [_c("i", { staticClass: "ph-custom ph-magnifying-glass" })]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-715bceec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-715bceec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/menus/SearchBarForm.vue
// module id = M7wJ
// module chunks = 0